export * from './p-component';
export * from './h1-component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/micro-components/index.ts